module.exports = __webpack_public_path__ + "img/P15-zh.5732520d.png";